if (document.querySelector('.projectheader__images-container')) {

    const projectImagesContainer = document.getElementsByClassName('projectheader__images-container');
    const projectImages = document.getElementsByClassName('projectheader__images');
    const projectImage = document.getElementsByClassName("projectheader__image");

    const carouselContainerClassList = ['carousel', 'slide'];
    const carouselInnerClass = 'carousel-inner';
    const carouselItemClassList = ['carousel__image', 'carousel-item'];

    let mediaQueryScreen = window.matchMedia('(min-width: 768px)');

    changeImageDisplay(mediaQueryScreen);

    function changeImageDisplay(e) {
          if (e.matches) {
              projectImagesContainer[0].classList.add(...carouselContainerClassList);
              projectImages[0].classList.add(carouselInnerClass);
              Array.from(projectImage).map(
                  (element) => {
                      element.classList.add(...carouselItemClassList);
                      return element
                  }
              );
          } else {
              projectImagesContainer[0].classList.remove(...carouselContainerClassList);
              projectImages[0].classList.remove(carouselInnerClass);
              Array.from(projectImage).map(
                  (element) => {
                      element.classList.remove(...carouselItemClassList);
                      return element;
                  }
              );
          }
    }

    mediaQueryScreen.addEventListener('change', changeImageDisplay);

}
